import { required, isEmail } from "@/utils/inputValidators";
import { StyledInputField } from "@/components/styledInputField/styledInputField";
import { UseFormReturn } from "react-hook-form";
import { IGiftCardFormFields } from "../types";
import { inputFieldTheme } from "../../../../utils/themes";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import { useTranslations } from "next-intl";
import { useId } from "react";

interface IRecipientEmail {
  title: string;
  placeholder: string;
  form: UseFormReturn<IGiftCardFormFields>;
  isRequired: boolean;
  giftCardSellingEnabled: boolean;
  merchantColor?: string;
}
export const RecipientEmail = ({
  title,
  placeholder,
  form,
  isRequired,
  giftCardSellingEnabled,
  merchantColor,
}: IRecipientEmail) => {
  const t = useTranslations("GiftCard");
  const emailId = useId();
  return (
    <div
      data-testid={applyDataTestId(pom.giftCard.recipientEmail)}
      className="w-full md:w-1/2"
    >
      <StyledInputField
        id={emailId}
        ariaLabelledby={emailId}
        theme={inputFieldTheme}
        label={title}
        name="recipientEmail"
        className="[&_.MuiOutlinedInput-root]:bg-white"
        placeholder={placeholder}
        form={form}
        validator={{
          required: isRequired ? required("Email", t("pleaseFillOut")) : false,
          isEmail: isEmail(t("invalidEmail")),
        }}
        disabled={!giftCardSellingEnabled}
        merchantColor={merchantColor}
      />
    </div>
  );
};
